import * as React from "react";

const IconArrowRight: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="currentColor"><polygon fill="currentColor" points="10.234 4.767 10.5 4.5 10.234 4.233 6.284 .267 6.019 0 5.487 .534 5.753 .8 9.061 4.122 .376 4.122 0 4.122 0 4.878 .376 4.878 9.061 4.878 5.753 8.2 5.487 8.466 6.019 9 6.284 8.733 10.234 4.767"  transform="translate(0 .033)"/></svg>;
};

export default React.memo(IconArrowRight);
